import React from 'react'
import { uncontrollable } from 'uncontrollable'
import classes from '../Navbar.module.scss'

export class NavbarTab extends React.Component {
  render () {
    const {
      className,
      href,
      active,
      onClick,
      children,
      ...restProps
    } = this.props

    const Tag = href ? 'a' : 'span'

    let compClassName = classes.navbarTab
    if (href || onClick) compClassName += ' ' + classes.clickable
    if (active) compClassName += ' ' + classes.active
    if (className) compClassName += ' ' + className
    if (href) compClassName += ' clear-link-style'

    let navbarTabNameClassName = classes.navbarTabName
    if (active) navbarTabNameClassName += ' text-primary'

    return (
      <Tag
        {...restProps}
        href={href}
        className={compClassName}
        onClick={onClick}
      >
        <span className={navbarTabNameClassName}>
          {children}
        </span>
      </Tag>
    )
  }
}

export default uncontrollable(
  NavbarTab,
  {
    selectedSubKey: 'onSelect'
  }
)
